import { ChangeEventHandler } from 'react';
import styled from 'styled-components';

import { DateTextInput } from '@components/Input/DateTextInput';

type BirthDatePickerProps = {
  birthDate?: string;
  onBirthDateChange: ChangeEventHandler<HTMLInputElement>;
  ageErrorMessage: string | null;
  showBirthdateValidation: boolean;
};
export const BirthDatePicker = ({
  birthDate,
  onBirthDateChange,
  ageErrorMessage,
  showBirthdateValidation,
}: BirthDatePickerProps): JSX.Element => (
  <StyledContainer>
    <h3>
      Date of Birth ({UK_DATE_FORMAT}) <span className='required'>*</span>
    </h3>
    <DateTextInput
      value={birthDate}
      onChange={onBirthDateChange}
      placeholder={UK_DATE_FORMAT}
      status={ageErrorMessage && showBirthdateValidation ? 'error' : undefined}
    />
    {showBirthdateValidation && (
      <p style={{ margin: 0, fontSize: '12px', color: 'red' }}>
        {ageErrorMessage}
      </p>
    )}
  </StyledContainer>
);

const UK_DATE_FORMAT = 'DD/MM/YYYY';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  h3 {
    margin: 0;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: ${({ theme }) => theme.palette.text[0]};

    span.required {
      color: ${({ theme }) => theme.palette.color[0]};
    }
  }
`;
